import { render } from "./S920_VetpointDaten.vue?vue&type=template&id=9d7cd246&scoped=true&ts=true"
import script from "./S920_VetpointDaten.vue?vue&type=script&lang=ts"
export * from "./S920_VetpointDaten.vue?vue&type=script&lang=ts"

import "./S920_VetpointDaten.vue?vue&type=style&index=0&id=9d7cd246&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d7cd246"]])

export default __exports__